import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestStatus } from '../types';

import { AuthState, FailedVerificationResponse, SuperAdmin } from './authTypes';

const initialState: AuthState = {
  superAdmin: {
    status: 'none'
  },
  loginStatus: 'none',
  verification: {
    status: 'none',
    toManyResends: false
  }
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSuperAdmin: (state, action: PayloadAction<SuperAdmin>) => {
      state.superAdmin = action.payload;
    },
    setSuperAdminStatus: (state, action: PayloadAction<RequestStatus>) => {
      state.superAdmin.status = action.payload;
    },
    clearSuperAdmin: state => {
      state.superAdmin = initialState.superAdmin;
    },
    setLoginStatus: (state, action: PayloadAction<RequestStatus>) => {
      state.loginStatus = action.payload;
    },
    updateVerificationStatus: (state, action: PayloadAction<RequestStatus>) => {
      state.verification.status = action.payload;
    },
    codeVerificationFailed: (state, action: PayloadAction<FailedVerificationResponse | Error>) => {
      const error = action.payload;

      state.verification.status = 'error';

      if (error instanceof Error) {
        state.verification.errorCode = 'NetworkError';
      } else {
        const {
          body: { type }
        } = error;

        state.verification.errorCode = 'Invalid';

        if (type === 'SpotMFACode_TooManyVerifyAttemptsError') {
          state.verification.errorCode = 'ToManyVerifyAttempts';
        }

        if (type === 'SpotMFACode_CodeExpiredError') {
          state.verification.errorCode = 'Expired';
        }
      }
    },
    onSendConfirmationCodeStart: state => {
      state.verification.toManyResends = false;
    },
    onSendConfirmationCodeSuccess: state => {
      state.verification.errorCode = undefined;
      state.verification.status = 'none';
    },
    resetVerification: state => {
      state.verification = { ...initialState.verification };
    }
  }
});

export const authReducer = authSlice.reducer;

export const {
  setSuperAdmin,
  clearSuperAdmin,
  setSuperAdminStatus,
  setLoginStatus,
  updateVerificationStatus,
  codeVerificationFailed,
  onSendConfirmationCodeStart,
  onSendConfirmationCodeSuccess,
  resetVerification
} = authSlice.actions;
